import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuEN from "../../components/en/MenuEN";
import FooterEN from "../../components/en/FooterEN";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Law Firm Frank Coel"}
                    description={"Coel Advocaten is a law firm located in the heart of Mechelen. It brings together experienced lawyers with varied profiles. Their areas of expertise range from family law, personal law, business and property law, to administrative law, civil service law, migration law, tax law, corporate law and criminal law including traffic law."}
                    url={"https://www.coeladvocaten.be/en"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en", language:"en" },
                    ]}
                />

                <MenuEN
                    switchUrlNL="/nl"
                    switchUrlFR="/fr"
                />
                
                <div className="paralax paralax-header">
                    <div className="slider">
                        <h1>Securing what matters</h1>
                        <h2>Coel Advocaten</h2>
                        <p></p>
                        <a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                    </div> 
                </div>
                
                <div className="team">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="cell">
                                    <div className="image">
                                        <img src="/static/images/ons-team-frank-thumb.jpg" />
                                    </div>
                                    <h3>Frank Coel</h3>
                                    <p>Frank graduated in Law in 1990 at the Vrije Universiteit Brussel. He has been a member of the bar since then. Frank completed an internship at Feremans, Vets & Verreydt in Mechelen ...</p>
                                    <a href="/en/frank-coel" alt="Frank Coel, administrative law, criminal law" className="button">Read more ...</a>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="cell">
                                    <div className="image">
                                        <img src="/static/images/ons-team-anna-thumb.jpg" />
                                    </div>
                                    <h3>Anna Mamchenkova</h3>
                                    <p>After graduating in accounting in 2012, Anna gained experience in various offices as an accountant and administrative assistant ...</p>
                                    <a href="/en/anna-mamchenkova" alt="Anna Mamchenkova, accounting and management" className="button">Read more ...</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="paralax paralax-content">
                    <div className="slider">
                        <h3>About us</h3>
                        <p>Our firm is home to a lawyer with extensive professional skills, in order to best embrace a wide spectrum of civil, tax, administrative, social and criminal law.</p>
                        <p>All these areas are covered in the broadest sense of the term.</p>
                        <p>Although we have solid experience and many years of practice, it is obviously not always possible for us to master all the technical aspects of certain files in order to lead them to a favorable outcome. This is why we have patiently established, over the years, many trusted external partnerships with, among others, doctors, engineers, psychologists, accountants, as well as managers.</p>
                        <p>Our contacts notably have the necessary technical expertise to help you determine and evaluate the extent of material, physical and moral damage. They can also provide you with psychological assistance, whether you are a victim or an accused. </p>
                        <p>Among them, managers and company auditors can analyze your accounting in depth and advise you in disputes between partners, acquisitions and mergers of companies.</p>
                        <p>We also regularly call on surveyors, architects and design offices for matters relating to the valuation of movable and immovable property in liquidations and distributions, damage, including planning damage, expropriation, leasing, agricultural law, real estate rental, as well as urban planning disputes, with authorities, contractors or architects, etc.</p>
                        <p>In short, our firm can rely, whenever necessary, on a wide pool of external experts who advise and assist it.</p>
                        <p>In social law, we specialize in disputes for statutory and contractual employees, including civil servant law, as well as in tax disputes and disputes with governments and third parties.</p>
                        <p>We can advise you in both national languages and, in the event of an international dispute, in English. The office also has the necessary translators and interpreters.</p>
                        <p>The office is completely independent and acts mainly in conflicts between citizens, and between citizens and the government.</p>

                        <h3>Is your company in difficulty? We can help you! </h3>
                        <p>Whether you are encountering temporary difficulties or experiencing a situation that worsens over time, <b>filing for bankruptcy is not always an inevitability</b>! It is often possible to <b>rectify</b> your company's situation, <b>resolve</b> its cash flow problems and return to growth and profit. </p>
                        <p>Our team has three assets to help you get your business back on track:</p>
                        <p>
                            <ul>
                                <li>A <b>proven methodology</b>: we have developed over time a working method that allows us to quickly evaluate the situation, identify solutions to the different problems you encounter and implement them with speed and efficiency.</li>
                                <li><b>Complementary skills</b>: our team brings together the necessary accounting, administrative, legal and tax skills for a global management of your situation.</li>
                                <li>A <b>vast network of partners</b>: we can also call on, if necessary, trusted professionals (notaries, bailiffs, experts, surveyors…) with whom we have established long-term relationships.</li>
                            </ul>
                        </p>
                        <p><h4>First step: a diagnosis of your situation</h4></p>
                        <p>First of all, we take the time to carry out a complete diagnosis of your company from all angles: accounting, tax, social, commercial, managerial, real estate, etc. If necessary, we also bring your accounting up to date. Then…</p>
                        <p>&nbsp;</p>
                        <a href="/en/companies-in-difficulty" className="button">Companies in difficulty</a>
                        <p>&nbsp;</p>
                    </div>
                </div>

                <FooterEN />
            </Layout>
        );
    }
}

export default Index;
